import { Component } from '@angular/core';

import { HomeDataService } from '../../services/home-data.service';
import { ConfigService } from 'src/app/services/auth/config.service';

export interface Notification {
  id: number;
  notificationSubj: string;
  notificationNo: string;
  notificationDoc: string;
  notificationDocType: string;
  notificationDt: Date;
  actionBy: number;
  actionDt: Date;
  statusCd: string;
  verifiedby: number;
  verifieddt: Date;
}
@Component({
  selector: 'app-all-notifications',
  templateUrl: './all-notifications.component.html',
  styleUrls: ['./all-notifications.component.scss']
})
export class AllNotificationsComponent {

  constructor(private homeDataService:HomeDataService,private configService:ConfigService){}
notifications: any[] = [];
  ngOnInit() {
    this.getAllNotifications();
  }
  getAllNotifications() {

this.notifications=[]
    this.homeDataService.getNotifications().subscribe({
      next: (response) => {

        if (response.status === 200) {
          // this.rows = response.data;
          this.notifications = [...response.data];
    console.log(response) 
 
        } else {
         // this.toastService.showError(response?.message)
        }
      },
      error: (error) => {
     
      },
    });



}

  downloadFile(fileName: string) {
    const fileUrl = this.configService.getFileUrl() + fileName;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank';
    link.click();
  }
sectionTitle = 'Departmental Notifications Published in H.P. Govt. Gazette';

  links = [
    {
      group: 'Reports & Information',
      items: [
        { label: 'View Administrative Report', url: '#' },
        { label: 'Properties of Officials', url: '#' },
        { label: 'Training Manual', url: '#' }
      ]
    },
    {
      group: 'Establishment Section',
      items: [
        { label: 'R&P Rules and Seniority', url: '#' },
        { label: 'Transfer Orders', url: '#' },
        { label: 'Promotion Orders', url: '#' }
      ]
    },
    {
      group: 'Committees',
      items: [
        { label: 'Sexual Harassment Committee', url: '#' }
      ]
    }
  ];
  pageTitle = 'General Notifications';

  
}


